export const COMPANY = {
  brand: "Halfa Stamps",
  site: "www.halfastamps.it",
  owner: "Scrimieri Dario D.I.",
  address: "Via Cavalcavia, 98 - 47521 Cesena (FC)",
  vat: "03534270404",
  rea: "FO - 305140",
  email: "amministrazione@halfalaser.it",
  phone: "0547 611342",
  updated: "19 giugno 2026",
};
